'use client';
import apiClient from './apiClient';

/** 會員相關 */
class AnaClient {
    // 建立 accessLog
    createAccessLog = (accessLog) =>
        apiClient.post('/ana/access-log', {
            accessLog,
        });
}

const anaClient = new AnaClient();

export default anaClient;
